import { ActionListItem, DropOverActionList } from "client/Components";
import { OpenItemMenuState, useItemDropOverMenuProps } from "client/Hooks";
import { isNotNil } from "client/Misc/utils";
import { localize } from "client_legacy/ndaw/culture";
import { ReactElement } from "react";

export type GroupGlobalNavigationItemMenuProps = {
	target: HTMLElement;
	onDelete(): void;
	onCreateShareSpace(): void;
	onAddAppAsSpace(): void;
	menuTitle: string;
	onClose: () => void;
	menuState: OpenItemMenuState;
};

export const GroupGlobalNavigationItemMenu = (props: GroupGlobalNavigationItemMenuProps): ReactElement => {
	const {
		target,
		onDelete,
		onAddAppAsSpace,
		onCreateShareSpace,
		menuTitle,
		onClose,
		menuState
	} = props;

	const {
		contentAlignment,
		targetAlignment,
		closeOnMouseDown
	} = useItemDropOverMenuProps(
		menuState,
		{
			contextMenuContentAlignment: "tl",
			moreMenuContentAlignment: "tr",
			moreMenuTargetAlignment: "mc"
		}
	);

	return (
		<DropOverActionList
			target={target}
			onClose={onClose}
			contentAlignment={contentAlignment}
			targetAlignment={targetAlignment}
			menuTitle={menuTitle}
			closeOnMouseDown={closeOnMouseDown}
		>
			<ActionListItem
				onClick={onCreateShareSpace}
				text={localize("_CreateSharedSpace")}
				trackingId="create-shared-space"
				icon="objects-column"
			/>
			{isNotNil(onAddAppAsSpace) && (
				<ActionListItem
					onClick={onAddAppAsSpace}
					text={localize("_AddWebContentAsSpace")}
					trackingId="open-app-as-tab"
					icon="code"
				/>
			)}
			<ActionListItem
				onClick={onDelete}
				text={localize("_Delete")}
				trackingId="delete"
				icon="trash-can"
			/>
		</DropOverActionList>
	);
};
GroupGlobalNavigationItemMenu.displayName = "GroupGlobalNavigationItemMenu";